module.exports = __webpack_public_path__ + "static/HKGrotesk-MediumItalic-dc54af88b68a187632252633c1467be2.woff";